<script>
  import LongTextTooltipCell from '../LongTextTooltipCell.svelte';

  export let eventData;

  $: affectedEntity = eventData?.affectedEntity ?? {};
  $: arn = affectedEntity.arn ?? '—';
</script>

<h6>ARN:</h6>
<LongTextTooltipCell text={arn} />
